import React from "react";
import { DirectoryView } from "@rankmi/ats-app";
import { RequestProfileComponent } from "@fcomponents/molecules/RequisitionFormViewer";
import "./UniqApplicant.scss";

const UniqApplicant = ({
  currentUser,
  tenantId,
  isAdmin,
  applicantSections,
  currentUserFullName,
  canSeeReferredTable,
  canUseSegments
}) => {
  return (
    <DirectoryView
      isAdmin={isAdmin}
      canUseSegments={canUseSegments}
      applicantSections={applicantSections}
      currentUser={{
        fullName: currentUserFullName,
        avatar: currentUser.avatar || "",
      }}
      registeredComponents={{
        requestProfileComponent: RequestProfileComponent
      }}
      canSeeReferredTable={!canSeeReferredTable}
    />
  );
};

export default UniqApplicant;
